
import { useResponsive } from "../../hooks/useResponsive.js";
import { BASE_GAP_CLASS } from "../../services/lib/constants.js";
import { getMediaImages } from "../../services/utils/helpers.js";

import { DimOverlay } from "../ui/Overlays.js";

function MediaHero({ media, small = false, children }) {
    console.log("MediaHero", media);
  // Getting image paths
  const { posterPath, backgroundImage } = getMediaImages(media);

  // Media query flags
  const { isXS, isSM, isMD, isLG } = useResponsive();

  // Poster widths
  let basicWidth, smallWidth;
  switch (true) {
    case isXS:
      basicWidth = "100%";
      smallWidth = "25rem";
      break;
    case isSM:
      basicWidth = "30rem";
      smallWidth = "25rem";
      break;
    case isMD:
      basicWidth = "22rem";
      smallWidth = "25rem";
      break;
    case isLG:
      basicWidth = "32rem";
      smallWidth = "25rem";
      break;
    default:
      basicWidth = "40rem";
      smallWidth = "25rem";
  }

  return (
    <div
      className={`sm:flex items-start rounded-lg overflow-hidden max-xl:gap-4 ${BASE_GAP_CLASS}`}
    >
      <img
        src={posterPath}
        className="rounded-lg object-contain h-auto flex-none"
        style={{ width: small ? smallWidth : basicWidth }}
        alt={media.title || media.name}
        title={`${media.title || media.name} poster`}
      />
      <div
        style={{
          backgroundImage,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
        className="basis-full relative flex flex-col max-sm:mt-6 sm:px-10 sm:py-8 rounded-lg min-h-[220px] sm:min-h-[300px] md:min-h-[420px]"
      >
        <DimOverlay />
        {children}
      </div>
    </div>
  );
}

export default MediaHero;
